import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Accordion,
  Badge,
  FilterAccordionHeader,
  IconButton,
} from '@folio/stripes-components';
import { FormattedMessage, useIntl } from 'react-intl';
import css from '../styles.css';
import CategoryFields from './CategoryFields';
import DeleteCategoryModal from '../Categories/DeleteCategoryModal';

function CategoryAccordion({
  basePath,
  category,
  categoryFields,
  refetch,
  refreshCategories,
  index,
}) {
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const [toggle, setToggle] = useState(true);
  const intl = useIntl();
  const localizedCategoryName = category?.name?.find(
    (field) => field?.locale === intl.locale,
  )?.value;

  const renderAccordionHeader = () => {
    return (
      <>
        {/* <IconButton
          id="customFields-list-pane-lastMenu-new-field-btn"
          // buttonStyle="primary"
          marginBottom0
          to={`${basePath}/customfields/create`}
          icon="plus-sign"
        /> */}
        <IconButton
          icon="edit"
          to={`${basePath}/category/${category?.id}/edit`}
        />
        <IconButton
          icon="trash"
          onClick={() => {
            setOpenDeleteModal(true);
          }}
          onMouseDown={(e) => e.preventDefault()}
        />
        <div className={css.badgeStyle}>
          <Badge>{categoryFields?.length || 0}</Badge>
        </div>
      </>
    );
  };

  return (
    <div key={category.id}>
      <Accordion
        id={`custom-fields-category-accordion-${category.id}`}
        label={<h2>{localizedCategoryName}</h2>}
        onToggle={() => setToggle(!toggle)}
        open={toggle}
        separator={index !== 0}
        closedBycustom
        header={FilterAccordionHeader}
        displayWhenOpen={renderAccordionHeader()}
        displayWhenClosed={renderAccordionHeader()}
      >
        <CategoryFields
          basePath={basePath}
          categoryFields={categoryFields}
          refetch={refetch}
        />
      </Accordion>
      <DeleteCategoryModal
        open={openDeleteModal}
        onClose={() => setOpenDeleteModal(false)}
        categoryId={category.id}
        isEmpty={categoryFields?.length === 0}
        refetch={refreshCategories}
      />
    </div>
  );
}

CategoryAccordion.propTypes = {
  basePath: PropTypes.string,
  category: PropTypes.object,
  categoryFields: PropTypes.arrayOf(PropTypes.object),
  refetch: PropTypes.func,
  refreshCategories: PropTypes.func,
  index: PropTypes.number,
};

export default CategoryAccordion;
